import { useMemo } from "react";
import { createLoadingStateFromPromise } from "_common/loaders/loadingStateUtils";

export function useLoadingFromPromiseForPageRouter<TValue>(promise?: Promise<TValue>) {
    return useMemo(() => (promise ? createLoadingStateFromPromise(promise) : undefined), [promise]);
}
